import { useQuery } from '@tanstack/react-query'
import { employerGuidanceKey } from './keys'
import { getEmployerGuidance } from 'api/shift'

type UseEmployerGuidance = Parameters<typeof getEmployerGuidance>[0]

export function useEmployerGuidance(options: UseEmployerGuidance) {
  const { positionId, locationId, mileage, shiftDurationHours } = options
  return useQuery({
    queryKey: employerGuidanceKey(
      positionId,
      locationId,
      mileage,
      shiftDurationHours
    ),
    queryFn: () => getEmployerGuidance(options),
  })
}
